import { DateTime } from 'luxon';
import { Message } from '../chat.model';

/** The shared local minute of a message's creation time. */
function minuteKey(createdAt?: string): string | undefined {
  if (!createdAt) return undefined;
  const date = DateTime.fromISO(createdAt);
  return date.isValid ? date.startOf('minute').toISO() : undefined;
}

/** Whether two consecutive messages were created in the same local hour and minute. */
export function sharesMinute(previous: Message, next: Message): boolean {
  const previousKey = minuteKey(previous.createdAt);
  return previousKey !== undefined && previousKey === minuteKey(next.createdAt);
}
